// jQuery(document).ready(function ($) {
//     $('.CatsFilter .item').click(function(e){
//         e.preventDefault();
        
//         $('.CatsFilter .item').removeClass("active");
//         $(this).addClass("active");

//         let catID = $(this).data("id");

//         $('.swiper-slide').addClass("hidden");
//         $('.swiper-slide[data-id="' + catID +'"]').removeClass("hidden");
        
//     })
// });